<template>  
  <v-container grid-list-lg fluid class="ma-0 pa-0">
    <v-layout row>
      <v-flex xs12 v-if="skeletonLoading">
        <v-skeleton-loader          
          type="card, article, actions"
          style="width:100%"
        ></v-skeleton-loader>
      </v-flex>
      <v-flex xs12 md12 v-else>
        <form @submit.prevent="onsubmit">          
          <v-card>                                
            <v-toolbar flat dense :color="jilid.color=='#fff' ? 'cyan':jilid.color " dark>
              <img src="logo.png" style="height:40px;" class="mt-1"/>                          
              <v-spacer/>              
            </v-toolbar>
            <v-card-text>
              <v-toolbar-title>{{jilid.name}}</v-toolbar-title>
              <p><strong>Description -</strong> {{jilid.description}}</p>
              <table class="black--text">
                <tbody>
                  <tr>
                    <td class="py-1" valign="top">ID</td>
                    <td class="pa-1" valign="top">:</td>
                    <td class="pa-1" valign="top">{{fm.code}}</td>
                  </tr>
                  <tr>
                    <td class="py-1" valign="top">Tanggal</td>
                    <td class="pa-1" valign="top">:</td>
                    <td class="pa-1" valign="top">{{fm.date}}</td>
                  </tr>
                  <tr>
                    <td class="py-1" valign="top">Nama</td>
                    <td class="pa-1" valign="top">:</td>
                    <td class="pa-1" valign="top">{{fm.name}}</td>
                  </tr>
                  <tr>
                    <td class="py-1" valign="top">Phone</td>
                    <td class="pa-1" valign="top">:</td>
                    <td class="pa-1" valign="top">{{fm.phone}}</td>
                  </tr>
                  <tr>
                    <td class="py-1" valign="top">Gender</td>
                    <td class="pa-1" valign="top">:</td>
                    <td class="pa-1" valign="top">{{fm.gender == 'L'? 'Laki-laki':'Perempuan'}}</td>
                  </tr>
                  <tr>
                    <td class="py-1" valign="top">Alamat</td>
                    <td class="pa-1" valign="top">:</td>
                    <td class="pa-1" valign="top">{{fm.address}} </td>
                  </tr>
                  <tr>
                    <td class="py-1" valign="top">TPS</td>
                    <td class="pa-1" valign="top">:</td>
                    <td class="pa-1" valign="top">
                      <span v-if="tps.find(x=>x.id==fm.tps_id)">{{tps.find(x=>x.id==fm.tps_id).name}}</span>
                    </td>
                  </tr>  
                  <tr>
                    <td class="py-1" valign="top">Kelurahan</td>
                    <td class="pa-1" valign="top">:</td>
                    <td class="pa-1" valign="top">
                      <span v-if="kelurahan.find(x=>x.id==fm.addr_idkel)">{{kelurahan.find(x=>x.id==fm.addr_idkel).name}}</span>                      
                    </td>
                  </tr>
                  <tr>
                    <td class="py-1" valign="top">Kecamatan</td>
                    <td class="pa-1" valign="top">:</td>
                    <td class="pa-1" valign="top">
                      <span v-if="kecamatan.find(x=>x.id==fm.addr_idkec)">{{kecamatan.find(x=>x.id==fm.addr_idkec).name}}</span>                      
                    </td>
                  </tr>
                  <tr>
                    <td class="py-1" valign="top">Kabupaten/Kota</td>
                    <td class="pa-1" valign="top">:</td>
                    <td class="pa-1" valign="top">
                      <span v-if="kabupaten.find(x=>x.id==fm.addr_idkab)">{{kabupaten.find(x=>x.id==fm.addr_idkab).name}}</span>                      
                    </td>
                  </tr>
                  <tr>
                    <td class="py-1" valign="top">Provinsi</td>
                    <td class="pa-1" valign="top">:</td>
                    <td class="pa-1" valign="top">
                      <span v-if="provinsi.find(x=>x.id==fm.addr_idpro)">{{provinsi.find(x=>x.id==fm.addr_idpro).name}}</span>
                    </td>
                  </tr>
                                  
                </tbody>
              </table>                                      
            </v-card-text>              
            <v-card-text class="caption" style="font-size: 12px!important;">
              <h3 class="mb-2">Questionnaire</h3>             
              <table>
                <template v-for="(quetion, i) in fm.responDtls">
                  <tr :key="i">
                    <td valign="top" class="text-center body-1">{{quetion.no}}.</td>
                    <td valign="top">
                      <p><span>{{quetion.question}}</span><br/>
                        <template v-if="quetion.type === 1">
                          <v-radio-group v-model="quetion.answer_id" hide-details class="mt-0 mb-3">
                            <v-radio required v-for="(opt,n) in quetion.option" :key="n" disabled="true"
                              :label="(opt.key?opt.key+'. ':'')+opt.value" :value="opt.id"
                            ></v-radio>
                          </v-radio-group>                          
                        </template>
                        <template v-else-if="quetion.type === 2">
                          <template v-for="(opt,n) in quetion.option">
                            <v-checkbox :key="n" disabled :required="Array.isArray(quetion.answer_jsonid) && quetion.answer_jsonid.filter(a=>(a!='null'&&a!==null)).length?false:'required'" v-model="quetion.answer_jsonid[n]" class="mt-1" :label="(opt.key?opt.key+'. ':'')+opt.value" :value="opt.id" hide-details></v-checkbox>                                        
                          </template>                          
                        </template>
                        <template v-else-if="quetion.type === 3">
                          <v-text-field disabled v-for="(opt,n) in quetion.option" v-model="quetion.answer_jsonvalue[n]" :key="n" type="text" :label="opt.key" small hide-details style="max-width:400px;margin-bottom:4px;" >
                            <span :set="quetion.answer_jsonkey[n] = opt.key"></span>
                          </v-text-field>
                        </template>
                      </p>
                    </td>
                  </tr>
                </template>
              </table>              
            </v-card-text>
            <v-card-actions class="pa-4">
              <v-spacer />              
            </v-card-actions>
          </v-card>
        </form>   
      </v-flex>            
    </v-layout>
  </v-container>    
</template>

<script>
import { debounce } from 'lodash'
import model from '@/app/models/Respon'
import st from '@/utils/cookies'
import cf from '@/app/config'
export default {
  data : () => ({  
    fm:{ 
      jilid_id: null, code: null, date:null, name: null, phone:null, gender:null, tps_id:null, address:null, geom:null,
      addr_idpro:null, addr_idkab: null, addr_idkec:null, addr_idkel:null, image:null, responDtls:[]
    },
    error:{ 
      jilid_id: [], code: [], date:[], name: [], phone:[], gender:[], tps_id:[], address:[], geom:[],
      addr_idpro: [], addr_idkab: [], addr_idkec:[], addr_idkel:[], image:[], responDtls:[]
    },
    jilid:{},
    headers: [
      {text:'No', value:'no', width:70},
      {text:'Key', value:'key', width:180},
      {text:'Value', value:'value'},
      {text:'', value:'action', width:50, sortable:false},
    ],
    disabled : {addr_idpro : false, addr_idkab: false, addr_idkec: false, addr_idkel:false},
    provinsi  : [], kabupaten : [], kecamatan : [], kelurahan : [], tps:[],
    provinsiLoading  : false, kabupatenLoading : false, kecamatanLoading : false, kelurahanLoading : false, tpsLoading:false,
    
    items:[],
    loading: false,
    isUpdate: false,  
    datepicker: false,  
    mode: 0,        
    nodes: [], nodeLoading:false,
    colorpicker:false,
    skeletonLoading:false,
  }),
  computed:{
    is_admin(){
      let roles = JSON.parse(st.get(cf.prefix+'roles'))
      return roles.includes('sys_admin');
    }
  },
  watch:{
    'fm.addr_idpro'(newId){if(newId){      
      model.node({id:newId, jilid_id:this.jilid.id, expand:'lembar,lembarDone'}).then(res=>{this.provinsi.push(res)});
      this.kabupatenLoading = true; //this.fm.addr_idkab = null;
      model.kabupaten({parent:newId, jilid_id:this.jilid.id, expand:'lembar,lembarDone'}).then(data=>{
        this.kabupaten=data; this.kabupatenLoading = false;  
        this.fm.addr_idkab = this.fm.addr_idkab && data.find(x=>x.id === this.fm.addr_idkab) ? this.fm.addr_idkab : null;         
      })
    }},
    'fm.addr_idkab'(newId){
      if(newId){      
        this.kecamatanLoading = true;
        model.kecamatan({parent:newId, jilid_id:this.jilid.id, expand:'lembar,lembarDone'}).then(data=>{
          this.kecamatan=data; this.kecamatanLoading = false;
          this.fm.addr_idkec = this.fm.addr_idkec && data.find(x=>x.id===this.fm.addr_idkec) ? this.fm.addr_idkec:null;
          if(this.kecamatan.find(x=>x.id===this.fm.addr_idkec)){
            this.fm.addr_postcode = this.fm.addr_postcode ? this.fm.addr_postcode:this.kecamatan.find(x=>x.id===this.fm.addr_idkec).kodepos;
          }  
        })
        model.node({id:newId, jilid_id:this.jilid.id, expand:'lembar,lembarDone'}).then(data=>{this.fm.addr_idpro = data.parent_id;})
      } else {
        this.fm.addr_idkec = null; this.kecamatan = []; 
      }
    },
    'fm.addr_idkec'(newId){
      if(newId){      
        this.kelurahanLoading = true; 
        model.kelurahan({parent:newId, jilid_id:this.jilid.id, expand:'lembar,lembarDone'}).then(data=>{
          this.kelurahan=data; this.kelurahanLoading = false;
          this.fm.addr_idkel = this.fm.addr_idkel && data.find(x=>x.id===this.fm.addr_idkel) ? this.fm.addr_idkel : null;           
        })      
        if(this.kecamatan.find(x=>x.id===newId)){
          let kodepos = this.kecamatan.find(x=>x.id===newId).kodepos;
          this.fm.addr_postcode = this.fm.addr_postcode ? this.fm.addr_postcode : kodepos; 
        }  
      } else {
        this.fm.addr_idkel = null; this.kelurahan = [];
      }
    },   
    'fm.addr_idkel'(newId, oldId){if(oldId===null && newId !== null){
      this.tpsLoading = true;      
      model.node({id:newId, jilid_id:this.jilid.id, expand:'lembar,lembarDone'}).then(data=>{
        this.kelurahan.push(data); 
        model.tps({idkel:data.id, jilid_id:this.jilid.id, expand:'lembar,lembarDone'}).then(res=>{
          this.tps = res.data;
          this.tpsLoading = false;
          setTimeout(()=>{
            print();
          }, 100)
        }) 
        this.skeletonLoading = false;       
      })              
    } else if(this.kelurahan.find(x=>x.id===newId)){
      this.tpsLoading = true;
      model.tps({idkel:newId, jilid_id:this.jilid.id, expand:'lembar,lembarDone'}).then(res=>{
        this.tps = res.data;
        this.tpsLoading = false;
      })
    }},
  }, 
  mounted(){
    this.fm.date = this.$moment().format('YYYY-MM-DD');

    if(this.$route.query.jilid_id){
      this.skeletonLoading = true;
      this.fm.jilid_id = this.$route.query.jilid_id;  
      model.jilid({id:this.fm.jilid_id, expand:'quetionnaires'}).then(data=>{
        Object.assign(this.jilid, data);
        if(this.jilid.node_id){
          model.node({id:this.jilid.node_id}).then(res=>{
            if(res.level){
              switch(parseInt(res.level)){
                case 1: this.fm.addr_idpro = res.id; 
                  this.disabled.addr_idpro = true;
                  break;
                case 2: this.fm.addr_idkab = res.id; 
                  this.disabled.addr_idpro = true;
                  this.disabled.addr_idkab = true;
                  break;
                case 3: this.fm.addr_idkec = res.id; 
                  this.disabled.addr_idpro = true;
                  this.disabled.addr_idkab = true;
                  this.disabled.addr_idkec = true;
                  break;
                case 4: this.fm.addr_idkel = res.id; 
                  this.disabled.addr_idpro = true;
                  this.disabled.addr_idkab = true;
                  this.disabled.addr_idkec = true;
                  this.disabled.addr_idkel = true;
                  break;
              }
            }            
          })
        }      
        if(this.$route.query.id){
          this.isUpdate = true; this.skeletonLoading = true;
          model.view({id:this.$route.query.id, expand:'responDtls'}).then(data=>{
            this.skeletonLoading = false;                
            Object.assign(this.fm, data);        
            this.fm.area_id = String(this.fm.area_id);
            if(!this.fm.jilid_id){
              this.$router.replace({name:'survey'});
              return;
            }
            if(Array.isArray(this.jilid.quetionnaires) && Array.isArray(this.fm.responDtls)){              
              this.jilid.quetionnaires.forEach(item=>{
                let question = this.fm.responDtls.find(x=>x.quetionnaire_id == item.id);
                if(question){
                  question.jilid_id = this.jilid.id;
                  question.no = item.no;
                  question.type = item.type;
                  question.question = item.question;
                  question.option = Array.isArray(item.option) ? item.option : JSON.parse(item.option);                    
                } else {
                  this.fm.responDtls.push({
                    quetionnaire_id:item.id,
                    jilid_id:this.jilid.id,
                    no:item.no,
                    type:item.type,
                    question:item.question,
                    option:Array.isArray(item.option) ? item.option : JSON.parse(item.option),
                    answer_id:null,
                    answer_key:null,
                    answer_value:null,
                    answer_jsonid:[],
                    answer_jsonkey:[],
                    answer_jsonvalue:[]
                  })
                }                
              });
            }
          })
        } else {
          if(!this.fm.jilid_id){
            this.$router.replace({name:'survey'});
            return;
          }
          if(Array.isArray(this.jilid.quetionnaires)){
            this.jilid.quetionnaires.forEach(item=>{
              this.fm.responDtls.push({
                quetionnaire_id:item.id,
                jilid_id:this.jilid.id,
                no:item.no,
                type:item.type,
                question:item.question,
                option:item.option,
                answer_id:null,
                answer_key:null,
                answer_value:null,
                answer_jsonid:[],
                answer_jsonkey:[],
                answer_jsonvalue:[]
              })
            });
          }          
        }                   
      })   
      this.$getLocation().then(coordinates => {
        this.fm.lat = coordinates.lat;
        this.fm.lng = coordinates.lng;
      });
    }               
  },
  methods: {
    search: debounce(function (e) {      
      this.readNodes(e.target.value)
    }, 800),

    readNodes(term){
      this.nodeLoading = true;
      model.nodes({q:term,level:this.fm.tingkat}).then(res=>{
        this.nodes = res.data;
        this.nodeLoading = false;
      })
    },
    
    addQuetion(){      
      let no = this.fm.quetionnaires.length + 1;
      this.fm.quetionnaires.push({no:no, question:null, type:1, option:[]})
    },

    delQuetion(i){
      this.fm.quetionnaires.splice(i, 1);
    },

    addOption(quetion){
      quetion.option.push({id:null, key:null, value: null});
    },

    delOption(quetion, item){
      quetion.option.splice(quetion.option.findIndex(x=>x===item), 1);
    },

    onsubmit(){
      this.clearErrors();
      if(this.validasiManual()){
        this.loading = true;  
        if(this.isUpdate){        
          model.update(this.fm, {id:this.fm.id}).then(res=>{this.responseSubmit(res)})
        } else {        
          model.create(this.fm).then(res=>{this.responseSubmit(res)})
        }
      }      
    },

    responseSubmit(res){
      this.loading = false;
      if(res){
        if(res.status === 200){
          window.getApp.$emit('showSnackbar', {text :'Data has been saved successfully', color: 'green', show:true});            
          this.$router.replace({name:'survey/respon', query:this.$route.query})                
        } else {
          this.validate(res.data);
        }
      } else {
        this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                                    
        this.$router.replace({name:'survey/respon', query:this.$route.query})                
      }
    },

    validate(data){      
      for(var i in data){        
        if(Array.isArray(this.error[data[i]['field']])){          
          this.error[data[i]['field']].push(data[i]['message']);
        }        
      }
    },

    clearErrors(){
      for(var key in this.error){
        this.error[key] = [];
      }      
    },

    validasiManual(){      
      if(this.fm.name == null){
        this.error.name = ['name cannot be blank'];
      }
      if(this.fm.gender == null){
        this.error.gender = ['gender cannot be blank'];
      }
      if(this.fm.addr_idkab == null){
        this.error.addr_idkab = ['Id Kab cannot be blank'];
      }
      if(this.fm.addr_idkec == null){
        this.error.addr_idkec = ['Id Kec cannot be blank'];
      }
      if(this.fm.addr_idkel == null){
        this.error.addr_idkel = ['Id Kel cannot be blank'];
      }
      

      let bersih = true;
      for(var key in this.error){
        if(Array.isArray(this.error[key])){
          if(this.error[key].length > 0){
            bersih = false;
          }
        }        
      }
      return bersih;
    }
  },
}
</script>

<style>
.ramping td, .ramping th {
    padding: 0 5px;
}
.v-data-table-header-mobile__wrapper .v-select {
    max-width:200px !important;
}
.v-label{
  font-size: 12px!important;
  color:#000 !important
}
</style>